import { FC, useEffect, useState } from "react";

import { IUserRoleItemForm } from "./table-user-roles.models";
import { UserRoleDisplay } from "./user-role.display";
import { UserRoleEdit } from "./user-role.edit";

export const UserRoleItem: FC<IUserRoleItemForm> = ({
  fieldName,
  index,
  value,
  setValueOuter,
  removeHandler,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <>
      {!inEdit && (
        <UserRoleDisplay
          fieldName={fieldName}
          removeHandler={removeHandler}
          value={value}
          index={index}
          onEdit={() => setInEdit(true)}
        />
      )}

      {inEdit && (
        <UserRoleEdit
          fieldName={fieldName}
          setValueOuter={setValueOuter}
          index={index}
          value={value}
          onCancelOuter={() => setInEdit(false)}
        />
      )}
    </>
  );
};
